// @flow
import WebComponent from '../src/webComponents/WebComponent';
import * as CursorSpinner from '../src/components/CursorSpinner';
import $ from 'jquery';

export default class EshopGalleryPopup extends WebComponent {
	constructor(props) {
		super(props);
		this.handleClick = this.handleClick.bind(this);
	}
	enterDocument() {
		this.on('click', this.handleClick);
	}
	handleClick(e) {
		const {
			item,
		} = this.props;

		e.preventDefault();
		CursorSpinner.pushToQueue('showEshopGalleryPopup');

		let targetUrl = window.location.href;
		if (targetUrl.indexOf('?') === -1) {
			targetUrl += '@gallery?ramJetLayoutContext=galleryPopup&activeItem=' + item;
		} else {
			targetUrl = targetUrl.replace('?', '@gallery?ramJetLayoutContext=galleryPopup&activeItem=' + item + '&');
		}

		$.get(targetUrl, (data) => {
			CursorSpinner.removeFromQueue('showEshopGalleryPopup');
			edeeshopPopup.createPopup(data, 'esp--gallery esp-eshop-gallery');
		});
	};
}



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/components/EshopGalleryPopup.js